export const dateInputPattern = /^(?:([0123]?\d)\.([01]?\d)\.(\d{4})|(\d{4})-([01]?\d)-([0123]?\d))$/;
export const toIsoDateString = (date) => {
    if (!date) {
        return '';
    }
    return date.toISOString().substring(0, 10);
};
export const addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
};
export const formatDate = (date) => date?.toLocaleDateString('de-DE', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
}) || '';
